import { adminHttpClient } from '../commons/adminHttpClient'
import PagedList from '../commons/pagedList'

export interface ExpenseTypeResponse {
  id: number
  name: string
  code: string
  active: boolean
  limitedHraEligible: boolean
}

const getExpenseTypes = (productId: number): Promise<ExpenseTypeResponse[]> =>
  adminHttpClient.get(`Expenses/DefaultExpenseTypesForDocReview/${productId}`)

export default getExpenseTypes
